var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "scroll_mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    style: {
      enableBackground: "new 0 0 102 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.scrollMark0{fill:#5A34E1;}\n\t.scrollMark1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "scrollMark0",
    cx: 51,
    cy: 51,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "scrollMark0",
    d: "M51,2c27,0,49,22,49,49s-22,49-49,49S2,78,2,51S24,2,51,2 M51,1C23.4,1,1,23.4,1,51s22.4,50,50,50 s50-22.4,50-50S78.6,1,51,1L51,1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "scrollMark1",
    d: "M61.7,56.5c0.9,0.9,0.9,2.3,0,3.2l-9.1,9.1c-0.9,0.9-2.3,0.9-3.2,0l-9.1-9.1c-0.9-0.9-0.9-2.3,0-3.2 c0.9-0.9,2.3-0.9,3.2,0l5.2,5.2V35.4c0-1.3,1-2.3,2.3-2.3c1.3,0,2.3,1,2.3,2.3v26.3l5.2-5.2C59.4,55.6,60.8,55.6,61.7,56.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollMark);
export default __webpack_public_path__ + "static/media/scroll-mark.606d7b5ee60d8d2b0aae776407a66f09.svg";
export { ForwardRef as ReactComponent };